import React from 'react'
import { Form, Modal, Table } from 'antd'
import logo from '../static/images/New_logo.jpg'
import useDownloadPdf from '../hooks/DownloadPdf'
import axios from 'axios'
import apiRequest from '../hooks/ApiRequest'
import { toast } from 'react-toastify'
import hasPermissions from '../hooks/Permissions'
function roundvalue(value) {
  if (value > 0) {
    return parseFloat(value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0])
  }
}
const productNameInLocalStorage = localStorage.getItem('productName');
class ViewPolicy extends React.Component {
  constructor(props) {
    super(props)
    this.downloadPdf = useDownloadPdf().generatePdf
    this.state = {
      policyId: localStorage.getItem('PolicyID'),
      quotationId: '',
      policyEndDate: '',
      PolicyStartDate: '',
      policystatus: '',
      PolicyAnnualPremium: '',
      totalannualpremium: '',
      clientname: '',
      RefundableAmount: '0.0',
      policyProRataPremium: '',
      policyRiskCover: '',
      policyRiskCoverItems: '',
      documentPermissions: {},
      totalSumInsured: 0,
      totalProRataPremium: 0,
      transactionDate: '',
      currency: '',
      productname: '',
      client_mobile: '',
      client_id_number: '',
      client_address: '',
      client_age: '',
      policyNumber: '',
      DocumentData: [],
      productId: parseInt(localStorage.getItem('productId')),
      columns: [
        {
          key: 'policy_cover',
          title: 'Policy Cover ',
          dataIndex: 'policy_cover',
        },
        {
          key: 'riskitem',
          title: 'Risk Item ',
          dataIndex: 'riskitemname',
        },
        {
          key: 'address',
          title: 'Risk Address',
          dataIndex: 'address',
        },
        ...(productNameInLocalStorage === 'LEGAL INSURANCE'
          ? [
            {
              key: 'monthlyPayment',
              title: 'Monthly Payment($)',
              dataIndex: 'monthlypremium',
            },
          ]
          : [
            {
              key: 'suminsured',
              title: 'Sum Insured',
              dataIndex: 'suminsured',
              render: suminsured => {
                return parseFloat(suminsured).toFixed(2)
              },
            },
            {
              key: 'Proratapremium',
              title: 'Premium',
              dataIndex: 'annualpremium',
              render: annualpremium => {
                return parseFloat(annualpremium).toFixed(2)
              },
            },
          ]),
      ],
      columnsForFCP: [
        {
          key: 'relation',
          title: 'Relationship',
          dataIndex: 'relationship',
        },
        // {
        //   key: 'policy_cover',
        //   title: 'Policy Cover ',
        //   dataIndex: 'policy_cover',
        // },
        // {
        //   key: 'riskitem',
        //   title: 'Risk Item ',
        //   dataIndex: 'riskitemname',
        // },
        {
          key: 'name',
          title: 'Members Name',
          dataIndex: 'membername',
        },
        {
          key: 'gender',
          title: 'Gender',
          dataIndex: 'gender',
        },
        {
          key: 'age',
          title: 'Age',
          dataIndex: 'age',
        },
        ...(parseInt(localStorage.getItem('productId')) === 3
          ? [
            {
              key: 'sumInsured',
              title: 'Sum Insured',
              dataIndex: 'suminsured',
              render: (suminsured) => { return (parseFloat(suminsured).toFixed(2)) },
            },
            // {
            //   key: 'rate',
            //   title: 'Premium Rate',
            //   dataIndex: 'rate',
            //   render: (rate) => { return (parseFloat(rate).toFixed(2)) },
            // },
            // {
            //   key: 'termpremium',
            //   title: 'Term Premium',
            //   dataIndex: 'termpremium',
            //   render: (termpremium) => { return (parseFloat(termpremium).toFixed(2)) },
            // },
            {
              key: 'annualpremium',
              title: 'Premium',
              dataIndex: 'annualpremium',
              render: (annualpremium) => { return (parseFloat(annualpremium).toFixed(2)) },
            },
          ]
          : [
            {
              key: 'sumInsured',
              title: 'Sum Insured',
              dataIndex: 'suminsured',
              render: (suminsured) => { return (parseFloat(suminsured).toFixed(2)) },
            },
            // {
            //   key: 'rate',
            //   title: 'Premium Rate',
            //   dataIndex: 'rate',
            //   render: (rate) => { return (parseFloat(rate).toFixed(2)) },
            // },
            // {
            //   key: 'termpremium',
            //   title: 'Term Premium',
            //   dataIndex: 'termpremium',
            //   render: (termpremium) => { return (parseFloat(termpremium).toFixed(2)) },
            // },
            {
              key: 'annualpremium',
              title: 'Premium',
              dataIndex: 'annualpremium',
              render: (annualpremium) => { return (parseFloat(annualpremium).toFixed(2)) },
            },
          ]),
      ],
      data: [],
      status: '',
    }
    this.calculateRefundableAmount = this.calculateRefundableAmount.bind(this)
    this.findDayDifference = this.findDayDifference.bind(this)
  }
  fetchDocument = async id => {
    const DocumentData = await apiRequest(
      process.env.REACT_APP_BASE_URL_DOCUMENT + `/Document/ByEntity/${id}/0`,
      'GET',
    )
    this.setState({ DocumentData: DocumentData?.data?.data })
  }

  ApproveDocuments = async () => {
    const statusUpdateUrl = `${process.env.REACT_APP_BASE_URL_MICROSERVICE}/Policy/StatusUpdate/status-update`;
    const statusUpdatePayload = {
      id: this.state.policyId,
      status: 4
    };
    const method = 'POST';
    try {
      const response = await apiRequest(statusUpdateUrl, method, statusUpdatePayload);
      if (response.success) {
        const SendMailToWroker = await apiRequest(process.env.REACT_APP_BASE_URL + `/Policy/SendEmailToCustomer/send-email-to-customer/${this.state.policyId}`, 'POST');
        toast.success(response.responseMessage);
        this.props.closeModal();
      } else {
        toast.error(response.error || "Status update failed.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    }
  }


  componentDidMount() {
    debugger;
    const { policyId } = this.state
    const permissions = hasPermissions('Document');
    this.setState({ documentPermissions: permissions }, () => {
      // console.log('Saved Policy permissions', this.state.policyPermissions)
    })
    apiRequest(
      `${process.env.REACT_APP_BASE_URL}/Policy/GetPolicybyid/${policyId}`,
      'GET',
    )
      .then(response => {
        const policyDetail = response.data?.policydetail
        const customerDetail = response.data?.customerdetail
        if (!policyDetail || !customerDetail) {
          console.warn('Policy or Customer data missing')
          return
        }
        debugger;
        // Set Policy Status
        if (policyDetail.policystatus) {
          this.setState({ PolicyStatus: policyDetail.policystatus })
        }
        // Set Risk Covers
        if (
          Array.isArray(policyDetail.riskitemdetails) &&
          policyDetail.riskitemdetails.length > 1
        ) {
          const covers = policyDetail.riskitemdetails
            .map(item => item.policy_cover)
            .join(', ')
          this.setState({ policyRiskCover: covers })
        } else {
          this.setState({ policyRiskCover: policyDetail.policyriskcover })
        }
        // Client details
        let clientname = ''
        if (customerDetail.entitytype !== 'Business') {
          clientname = `${customerDetail.clientfirstname || ''} ${customerDetail.clientsurname || ''
            }`
        } else {
          clientname = customerDetail.clientcorporatename || ''
        }

        // Set general state
        this.setState({
          clientname,
          client_mobile: customerDetail.clientcontactnumber,
          client_address: customerDetail.clientaddress1,
          client_age: customerDetail.clientage,
          client_id_number: customerDetail.nationalid,
          policyNumber: policyDetail.policynumber,
          PolicyStartDate: policyDetail.policystartdate,
          policyEndDate: policyDetail.policyexpirytdate,
          currency: policyDetail.currency,
          policyProRataPremium: policyDetail.grandtotalannualpremium,
          totalannualpremium: policyDetail.totalannualpremium,
          productname: policyDetail.productname,
          proratatotaltermpremium: policyDetail.proratatotaltermpremium,
          data: policyDetail.riskitemdetails || [],
          grandtotalannualpremium: policyDetail.grandtotalannualpremium,
          grandtotaltermpremium: policyDetail.grandtotaltermpremium,
        })

        // Transaction Date
        const createdDate = policyDetail.createddate?.toString().slice(0, 10)
        if (createdDate) {
          this.setState({ transactionDate: createdDate })
        }

        // Sum Insured & Monthly Premium Calculation
        let totalSumInsured = 0
        let monthlyPremium = 0

        if (Array.isArray(policyDetail.riskitemdetails)) {
          for (const item of policyDetail.riskitemdetails) {
            totalSumInsured += item.suminsured || 0
            monthlyPremium += item.monthlypremium || 0
          }
        }
        this.setState({
          totalSumInsured: roundvalue(totalSumInsured),
          proRata:
            policyDetail.productid === 3
              ? monthlyPremium
              : policyDetail.proratatotaltermpremium,
        })
        if (response.data?.policydetail?.policyid) {
          this.fetchDocument(response.data?.policydetail?.policynumber,)
        }
      })
      .catch(error => {
        console.error('Error fetching policy details:', error)
      })
  }

  findDayDifference(date1, date2) {
    // always round down
    return Math.floor(Math.abs(date2 - date1) / (1000 * 60 * 60 * 24))
  }
  componentWillUnmount() {
    localStorage.removeItem('PolicyID')
  }
  calculateRefundableAmount(date, datestring) {
    var Noofdays = this.findDayDifference(
      new Date(this.state.PolicyEndDate),
      new Date(datestring),
    )
    Noofdays = Noofdays + 1

    this.setState({
      RefundableAmount: roundvalue(
        this.state.PolicyAnnualPremium * (Noofdays / 365),
      ),
    })
  }

  render() {
    return (
      <div className="container-box" style={{ marginTop: '15px' }}>
        <div
          id="divToPrint"
          className="white-box-bg"
          style={{ padding: '30px 15px 50px' }}>
          {this.state?.PolicyStatus?.toLocaleLowerCase() == 'cancelled' ? (
            <div className="watermark-text">
              <h1>Cancelled</h1>
            </div>
          ) : (
            ''
          )}

          <div style={{ padding: '15px 0', width: '50%' }}>
            <img src={logo} className="logo-img" style={{ width: '250px' }} />
          </div>

          <div style={{ padding: '10px' }}>
            <div>
              <h4
                style={{
                  padding: '5px 2px',
                  fontSize: '14px',
                  fontWeight: '800',
                  margin: '0',
                  textTransform: 'capitalize',
                }}>
                Customer Details
              </h4>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '50%' }}>
                  <ul
                    style={{
                      padding: '5px 20px 20px 0',
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: '500',
                      margin: '0',
                      listStyle: 'none',
                    }}>
                    <li>Name : </li>
                    <li>Mobile:</li>
                    <li>Address:</li>
                    {productNameInLocalStorage !== 'LEGAL INSURANCE' ? (
                      <li>Age:</li>
                    ) : (
                      ''
                    )}
                    <li>National Id:</li>
                  </ul>
                </div>
                <div style={{ width: '50%' }}>
                  <ul
                    style={{
                      padding: '5px 20px 20px 0',
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: '500',
                      margin: '0',
                      listStyle: 'none',
                    }}>
                    <li>
                      {' '}
                      {this.state.clientname.includes('undefined')
                        ? this.state.clientname.slice(9) || '-'
                        : this.state.clientname || '-'}
                    </li>
                    <li>{this.state.client_mobile || '-'}</li>
                    <li>{this.state.client_address || '-'}</li>
                    <li>
                      {productNameInLocalStorage !== 'LEGAL INSURANCE'
                        ? this.state.client_age
                        : '-'}
                    </li>
                    <li>{this.state.client_id_number || '-'}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div>
              <h4
                style={{
                  padding: '5px 2px',
                  fontSize: '14px',
                  fontWeight: '800',
                  margin: '0',
                  textTransform: 'capitalize',
                }}>
                Policy Details
              </h4>
              {this.state.productId !== 3 && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ width: '50%' }}>
                    <ul
                      style={{
                        padding: '5px 20px 20px 0',
                        fontSize: '14px',
                        color: '#000',
                        fontWeight: '500',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li>Policy Number : </li>
                      <li>Period of Insurance:</li>
                      <li>Transaction Date:</li>
                      <li>Currency:</li>
                      <li>Annual Premium(including stamp duty)</li>
                      <li>Term Premium(including stamp duty)</li>
                    </ul>
                  </div>
                  <div style={{ width: '50%' }}>
                    <ul
                      style={{
                        padding: '5px 20px 20px 0',
                        fontSize: '14px',
                        color: '#000',
                        fontWeight: '500',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li>{this.state.policyNumber || '-'}</li>
                      <li>
                        {this.state.PolicyStartDate || '-'}
                        <b> To </b>
                        {this.state.policyEndDate || '-'}
                      </li>
                      <li>{this.state.transactionDate || '-'}</li>
                      <li>{this.state.currency || '-'}</li>
                      <li>{this.state.grandtotalannualpremium || '-'}</li>
                      <li>{this.state.grandtotaltermpremium || '-'}</li>
                    </ul>
                  </div>
                </div>
              )}
              {this.state.productId === 3 && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ width: '50%' }}>
                    <ul
                      style={{
                        padding: '5px 20px 20px 0',
                        fontSize: '14px',
                        color: '#000',
                        fontWeight: '500',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li>Policy Number : </li>
                      <li>Start Date:</li>
                      <li>Transaction Date:</li>
                      <li>Currency:</li>
                    </ul>
                  </div>
                  <div style={{ width: '50%' }}>
                    <ul
                      style={{
                        padding: '5px 20px 20px 0',
                        fontSize: '14px',
                        color: '#000',
                        fontWeight: '500',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li>{this.state.policyNumber || '-'}</li>
                      <li>{this.state.PolicyStartDate || '-'}</li>
                      <li>{this.state.transactionDate || '-'}</li>
                      <li>{this.state.currency || '-'}</li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
            <div>
              <h4
                style={{
                  padding: '5px 2px',
                  fontSize: '14px',
                  fontWeight: '800',
                  margin: '0',
                  textTransform: 'capitalize',
                }}>
                Product Details
              </h4>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '50%' }}>
                  <ul
                    style={{
                      padding: '0 20px 20px 2px',
                      color: '#000',
                      fontSize: '14px',
                      fontWeight: '700',
                      margin: '0',
                      listStyle: 'none',
                    }}>
                    <li>Product :</li>
                  </ul>
                </div>
                <div style={{ width: '50%' }}>
                  <ul
                    style={{
                      padding: '0 20px 20px 2px',
                      color: '#000',
                      fontSize: '14px',
                      fontWeight: '700',
                      margin: '0',
                      listStyle: 'none',
                    }}>
                    <li>{this.state.productname}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div>
              <h4
                style={{
                  padding: '5px 2px',
                  fontSize: '14px',
                  color: '#000',
                  fontWeight: '800',
                  margin: '0',
                  textTransform: 'capitalize',
                }}>
                Policy Cover Details
              </h4>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '50%' }}>
                  <ul
                    style={{
                      padding: '0 20px 20px 2px',
                      color: '#000',
                      fontSize: '14px',
                      fontWeight: '500',
                      margin: '0',
                      listStyle: 'none',
                    }}>
                    <li>Policy Cover:</li>
                  </ul>
                </div>
                <div style={{ width: '50%' }}>
                  <ul
                    style={{
                      padding: '0 20px 20px 2px',
                      color: '#000',
                      fontSize: '14px',
                      fontWeight: '500',
                      margin: '0',
                      listStyle: 'none',
                    }}>
                    <li>{this.state.policyRiskCover}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div>
              <h4
                style={{
                  padding: '5px 2px',
                  fontSize: '14px',
                  color: '#000',
                  fontWeight: '800',
                  margin: '0',
                  textTransform: 'capitalize',
                }}>
                Uploaded Documents
              </h4>

              {this.state.DocumentData?.length > 0 ? (
                this.state.DocumentData.map((doc, index) => (
                  <div key={index} style={{ marginBottom: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div style={{ width: '50%' }}>
                        <ul
                          style={{
                            padding: '0 20px 20px 2px',
                            color: '#000',
                            fontSize: '14px',
                            fontWeight: '500',
                            margin: '0',
                            listStyle: 'none',
                          }}>
                          <li>Document Name:</li>
                        </ul>
                      </div>
                      <div style={{ width: '50%' }}>
                        <ul
                          style={{
                            padding: '0 20px 20px 2px',
                            color: '#000',
                            fontSize: '14px',
                            fontWeight: '500',
                            margin: '0',
                            listStyle: 'none',
                          }}>
                          <li>{doc.documentName}</li>
                        </ul>
                      </div>
                    </div>

                    {/* Preview Section */}
                    {doc.filePath ? (
                      <div
                        style={{
                          marginTop: '10px',
                          border: '1px solid #ccc',
                          padding: '10px',
                          borderRadius: '5px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <span style={{ fontSize: '14px', color: '#000' }}>
                          {doc.documentName}
                        </span>
                        <a
                          href={`https://devsageninsurance.blob.core.windows.net/policy-doc/${doc.filePath}`}
                          download
                          style={{
                            padding: '6px 12px',
                            backgroundColor: '#007bff',
                            color: '#fff',
                            textDecoration: 'none',
                            borderRadius: '4px',
                            fontSize: '14px',
                          }}
                        >
                          Download
                        </a>
                      </div>
                    ) : (
                      <p style={{ fontSize: '14px', color: '#888' }}>
                        No file available
                      </p>
                    )}
                  </div>
                ))
              ) : (
                <p
                  style={{ fontSize: '14px', color: '#888', padding: '5px 2px' }}>
                  No documents uploaded yet.
                </p>
              )}
            </div>

            <div className="dataSource-grid">
              <Table
                rowKey={record => record.policyriskitemid}
                columns={
                  this.state.productId === 3 || this.state.productId == 5
                    ? this.state.columnsForFCP
                    : this.state.columns
                }
                dataSource={this.state.data}
                pagination={false}
              />

              {this.state.productId === 1 ||
                this.state.productId === 2 ||
                (this.state.productId === 4 && (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div
                      style={{
                        width: '25%',
                        textAlign: 'left',
                        padding: '10px  14px',
                      }}>
                      <ul
                        style={{
                          padding: '0 0px 20px 2px',
                          color: '#000',
                          fontSize: '14px',
                          fontWeight: '800',
                          margin: '0',
                          listStyle: 'none',
                        }}>
                        <li>Grand Totals</li>
                      </ul>
                    </div>
                    <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                      <ul
                        style={{
                          padding: '0 0px 20px 2px',
                          color: '#000',
                          fontSize: '14px',
                          fontWeight: '800',
                          margin: '0',
                          listStyle: 'none',
                        }}></ul>
                    </div>
                    <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                      <ul
                        style={{
                          padding: '0 0px 20px 2px',
                          color: '#000',
                          fontSize: '14px',
                          fontWeight: '800',
                          margin: '0',
                          listStyle: 'none',
                        }}>
                        <li>
                          {productNameInLocalStorage === 'LEGAL INSURANCE'
                            ? ''
                            : parseFloat(this.state.totalSumInsured).toFixed(2)}
                        </li>
                      </ul>
                    </div>
                    <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                      <ul
                        style={{
                          padding: '0 20px 20px 2px',
                          color: '#000',
                          fontSize: '14px',
                          fontWeight: '800',
                          margin: '0',
                          listStyle: 'none',
                        }}>
                        <li>
                          {productNameInLocalStorage === 'LEGAL INSURANCE'
                            ? parseFloat(
                              this.state.proratatotaltermpremium,
                            ).toFixed()
                            : parseFloat(
                              this.state.policyProRataPremium,
                            ).toFixed(2)}
                        </li>
                      </ul>
                    </div>
                  </div>
                ))}

              {this.state.productId === 3 && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    style={{
                      width: '25%',
                      textAlign: 'left',
                      padding: '10px  14px',
                    }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li>Grand Totals</li>
                    </ul>
                  </div>
                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}></ul>
                  </div>
                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li></li>
                    </ul>
                  </div>
                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li></li>
                    </ul>
                  </div>
                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li></li>
                    </ul>
                  </div>
                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li>
                        {parseFloat(this.state.totalSumInsured).toFixed(2)}
                      </li>
                    </ul>
                  </div>
                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li></li>
                    </ul>
                  </div>
                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li></li>
                    </ul>
                  </div>
                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 20px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li>{parseFloat(this.state.policyProRataPremium).toFixed(2)}</li>
                    </ul>
                  </div>
                </div>
              )}
              {this.state.productId === 5 && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    style={{
                      width: '25%',
                      textAlign: 'left',
                      padding: '10px  14px',
                    }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li>Grand Totals</li>
                    </ul>
                  </div>
                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}></ul>
                  </div>
                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li></li>
                    </ul>
                  </div>
                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li></li>
                    </ul>
                  </div>
                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li></li>
                    </ul>
                  </div>
                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      {/* <li>{parseFloat(this.state.totalSumInsured).toFixed(2)}</li> */}
                    </ul>
                  </div>
                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li></li>
                    </ul>
                  </div>
                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li></li>
                    </ul>
                  </div>
                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 20px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li>{parseFloat(this.state.policyProRataPremium).toFixed(2)}</li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className="pdf-btn-none"
          style={{ textAlign: 'right', marginBottom: '10px' }}>
          {this.state.documentPermissions.hasOwnProperty('20') && (
            this.state.PolicyStatus?.toLowerCase() === 'document_uploaded' && (
              <button
                className="primary"
                style={{ width: '200px', marginRight: '5px' }}
                onClick={() => this.ApproveDocuments()}>
                Approve Document
              </button>
            )
          )}
          <button
            className="primary"
            style={{ width: '200px' }}
            onClick={() => this.downloadPdf('divToPrint', 'download.pdf')}>
            Download
          </button>
        </div>

      </div>
    )
  }
}

const WrappedViewPolicy = Form.create({ name: 'Homeinsurance_list' })(ViewPolicy)

export default WrappedViewPolicy
